module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box-f"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "list"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig01"
    }
  }, [_c('em', [_vm._v("Blues in the Night")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#fig02"
    }
  }, [_c('em', [_vm._v("Blues in the Night")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Jammin’ the Blues")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig04",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Dead Reckoning")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig05",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Cover Girl")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig06",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("To Have and Have Not")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig07",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Phantom Lady")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig08",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Christmas Holiday")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig09",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Gilda")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Gilda")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Black Angel")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Man I Love")]), _vm._v(" lobby card publicity")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Red Shoes")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Red Shoes")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Words and Music")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Young Man with a Horn")]), _vm._v(" lobby card publicity")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Band Wagon")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Star Is Born")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Star Is Born")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Young at Heart")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Love Me or Leave Me")]), _vm._v(" publicity still")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e183708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/list.vue
// module id = 75
// module chunks = 0